import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "detect-player" }
const _hoisted_2 = { class: "ui-player-tip" }
const _hoisted_3 = { class: "prism-player-loading" }
const _hoisted_4 = { class: "prism-player-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ui-player-btn-box",
        style: {position:'relative',marginLeft:`${_ctx.tipPosition.marginLeft}px`,marginBottom:`${_ctx.tipPosition.marginBottom}px`}
      }, [
        _createVNode("span", null, _toDisplayString(_ctx.state.sizeTxt), 1),
        _createVNode("span", {
          class: "ui-player-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.playVideo && _ctx.playVideo(...args)))
        }, _toDisplayString(_ctx.state.goonTxt), 1)
      ], 4)
    ], 512), [
      [_vShow, _ctx.state.showPlayerTip]
    ]),
    _withDirectives(_createVNode("div", {
      class: "CYP_prismPlayer",
      id: _ctx.state.id
    }, null, 8, ["id"]), [
      [_vShow, _ctx.state.isShowPlayer === true]
    ]),
    _withDirectives(_createVNode("div", {
      class: "prism-player-default",
      style: {backgroundImage:`url(${_ctx.playData && _ctx.playData.cover ? _ctx.playData.cover : _ctx.state.backgroundImg})`}
    }, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.state.loadingImgSrc,
          width: "100%",
          height: "100%"
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.state.waitTxt), 1)
    ], 4), [
      [_vShow, _ctx.state.isShowPlayer === false]
    ])
  ]))
}